import {
  auth as baseAuth,
  db as baseDb,
  initFirebase as baseInitFirebase,
  storage as baseStorage,
} from "@/lib/firebase";

export const FIREBASE_PROJECT_ID = "drop-the-pitch";

export async function initFirebase() {
  await baseInitFirebase();

  const configuredProject = baseDb().app.options.projectId;
  if (configuredProject && configuredProject !== FIREBASE_PROJECT_ID) {
    console.warn(
      `Firebase initialized with projectId "${configuredProject}" (expected "${FIREBASE_PROJECT_ID}")`
    );
  }
}

export const auth = baseAuth;
export const db = baseDb;
export const storage = baseStorage;
